var $ = require('jquery')
  , ERROR_MSG = '网络发生了错误'
  , CHANNEL_PC = 'CHANNEL_PC'
  , CHANNEL_IOS = 'CHANNEL_IOS'
  , CHANNEL_ANDROID = 'CHANNEL_ANDROID'
  , CHANNEL_TYPES = [
      CHANNEL_PC, CHANNEL_ANDROID, CHANNEL_IOS
    ]
  , _ = require('underscore')
  , pingjs = require('widgets/ping')

module.exports = function ajaxEngageCurrentGame(gameCode, gameChannelType) {

  var gameChannelType = gameChannelType || CHANNEL_PC

  if (!_.contains(CHANNEL_TYPES, gameChannelType)) {
    throw new Error('gameChannelType is error: ' + gameChannelType)
  }

  var dfd = new $.Deferred()
    , SUCCESS = "1"

  $.ajax({
    type: 'POST'
  , url: '/track-followGame.html'
  , data: {
      id: gameCode
    , channel: gameChannelType
    }
  , dataType:'json'
  }).done(function(resp) {
    if (resp.status !== SUCCESS) {
      return dfd.reject(resp.msg || ERROR_MSG)
    }

    dfd.resolve(resp.data || {})
    
    pingjs.applyBiClick(gameCode)
  }).fail(function() {
    dfd.reject(ERROR_MSG)
  })

  return dfd.promise()
}
